import { useSelector } from 'react-redux';
import { selectUsers } from './useUsers';

export function useUser(userId) {
    const users = useSelector(selectUsers);
    return users[userId];
}
